module.exports = __webpack_public_path__ + "static/media/sasha-stories-XVTTK3wcYME-unsplash.96e8d8ac.jpg";